import { sellEnrollment } from 'api/operations/enrollmentService';
import { makeAutoObservable } from 'mobx';
import { createContext, useContext } from 'react';
import EnrollmentPeriodModule from 'store/modules/enrollment/enrollmentPeriodModule';
import { EnrollmentCoreData } from 'types/enrollmentService';

export class CloseDealPageStore {
  private _enrollmentPeriodModule = new EnrollmentPeriodModule();
  private _isLoading = false;

  get isLoading(): boolean {
    return this._enrollmentPeriodModule.isLoading || this._isLoading;
  }

  get enrollmentCoreData(): EnrollmentCoreData | null {
    return this._enrollmentPeriodModule.enrollmentCoreData;
  }

  get goBackUrl(): string | null {
    if (this.isLoading) {
      return null;
    }

    return `/post-submit-checklist/${this.enrollmentCoreData?.id}`;
  }

  get completeStepUrl(): string | null {
    if (this.isLoading) {
      return null;
    }

    return `/group/${this.enrollmentCoreData?.groupId}`;
  }

  public setIsLoading(isLoading: boolean): void {
    this._isLoading = isLoading;
  }

  public async loadInitialData(periodId: string): Promise<void> {
    await this._enrollmentPeriodModule.uploadEnrollmentPeriod(periodId);
  }

  public async closeDeal(): Promise<void> {
    if (!this.enrollmentCoreData) {
      throw new Error('EnrollmentPeriod is not uploaded!');
    }
    this.setIsLoading(true);
    await sellEnrollment(this.enrollmentCoreData?.id);
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}

const CloseDealPageStoreContext = createContext(new CloseDealPageStore());

export const useCloseDealPageStore = (): CloseDealPageStore => {
  return useContext(CloseDealPageStoreContext);
};

export { CloseDealPageStoreContext };
